<template>
  <section class="orange footer">
    <div class="container">
      <div class="footer-logo">
        <div class="img">
          <img src="@/assets/images/global/footer-logo.gif" alt=""/>
        </div>
      </div>
      <div class="footer-nav">
        <ul>
          <li>
            <a href="https://www.lorealdermatologicalbeauty.us/privacy-policy" target="_blank">Privacy Policy</a>
          </li>
          <li>
            <a href="https://www.lorealdermatologicalbeauty.us/terms-and-conditions" target="_blank">terms of use</a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'SunHeroFooter',
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";

.orange.footer {
  background: @color-yellow;

  & > div {
    z-index: 12;
  }

  &:before,
  &:after {
    content: "";
    opacity: 0.5;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      background-size: 50% 100%;
    }
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
    height: 124px;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      flex-flow: column;
      justify-content: center;
      height: 238px;
    }

    h1 {
      position: absolute;
      left: 0;
      width: 100%;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        position: relative;
      }
    }
  }

  .footer-nav {
    display: flex;

    ul {
      display: inline-flex;
      text-align: center;
      @media (max-width: ~"@{mq-md-bp}em") {
        // margin-left: auto;
        margin-left: -8%;
        position: relative;
        top: -46px;
      }

      li {
        list-style: none;
        text-align: center;
        margin-top: 0;
        margin-left: 20px;
        font-weight: bold;
        font-size: 1.3em;
        text-transform: uppercase;
        text-decoration: underline;
        cursor: pointer;
        @media (max-width: ~"@{mq-md-bp}em") {
          font-size: 12px;
        }
      }
    }
  }

  .footer-logo {
    display: flex;
    margin-right: auto;
    @media (max-width: ~"@{mq-md-bp}em") {
      margin-right: 0;
      position: relative;
      top: -20px;
    }

    img {
      width: 181px;
      height: auto;
      @media (max-width: ~"@{mq-md-bp}em") {
        position: relative;
        top: -14px;
        width: 241px;
      }
    }
  }
}
</style>
